import React from "react";
import { OnboardingLayout } from "../../../../components/shared";
import { AddService } from "../../../../components/expert/onboarding";
import {
  OnBoardingContextProvider
} from "../../../../contexts/expert/onboarding";

export function AddServiceIndex() {
  return (
    <OnBoardingContextProvider>
      <OnboardingLayout>
        <AddService />
      </OnboardingLayout>
    </OnBoardingContextProvider>
  );
}
